/**
 * Re-usable home sections — Trust Badges + How It Works.
 * Used on LandingPage (logged-out) and DashboardHome (logged-in).
 */
import { ShieldCheck, Lock, MessageCircle, FileText, MessageSquare, CalendarCheck } from "lucide-react";

export const TrustBadges = ({ language = "en" }) => {
  const items = [
    {
      icon: ShieldCheck,
      title_de: "Verifizierte Profis", title_en: "Verified Professionals",
      sub_de: "Qualität, der Sie vertrauen können", sub_en: "Quality you can trust",
    },
    {
      icon: Lock,
      title_de: "Sicher & Vertraulich", title_en: "Secure & Confidential",
      sub_de: "Ihre Daten sind geschützt", sub_en: "Your data is protected",
    },
    {
      icon: MessageCircle,
      title_de: "Direkte Kommunikation", title_en: "Direct Communication",
      sub_de: "Chat mit Experten", sub_en: "Chat with experts",
    },
  ];
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 bg-white/[0.04] border border-white/10 rounded-2xl p-4 backdrop-blur-sm" data-testid="trust-badges">
      {items.map((it, i) => {
        const Icon = it.icon;
        return (
          <div key={i} className="flex items-start gap-3">
            <div className="w-9 h-9 rounded-xl bg-[#0044CC]/20 border border-[#60a5fa]/30 flex items-center justify-center flex-shrink-0">
              <Icon className="w-4 h-4 text-[#60a5fa]" strokeWidth={2.2}/>
            </div>
            <div className="min-w-0">
              <p className="text-white font-semibold text-sm leading-tight">{it[`title_${language}`] || it.title_en}</p>
              <p className="text-blue-100/85 text-xs mt-0.5 leading-tight">{it[`sub_${language}`] || it.sub_en}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export const HowItWorks = ({ language = "en" }) => {
  const steps = [
    { icon: FileText,       title_de: "Anfrage stellen", title_en: "Submit your request" },
    { icon: MessageSquare,  title_de: "Direkt verbinden", title_en: "Connect directly" },
    { icon: CalendarCheck,  title_de: "Termin buchen",    title_en: "Book appointments" },
  ];
  return (
    <div data-testid="how-it-works">
      <h2 className="text-white font-bold text-lg mb-4" style={{ fontFamily: "Chivo, sans-serif" }}>
        {language === "de" ? "So funktioniert's" : language === "fr" ? "Comment ça marche" : language === "it" ? "Come funziona" : "How it works"}
      </h2>
      <div className="flex items-center gap-2 sm:gap-4">
        {steps.map((s, i) => {
          const Icon = s.icon;
          return (
            <div key={i} className="flex items-center flex-1">
              <div className="flex flex-col items-center gap-2 flex-1">
                <div className="relative">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-2xl bg-white/[0.06] border border-white/10 flex items-center justify-center">
                    <Icon className="w-5 h-5 sm:w-6 sm:h-6 text-[#60a5fa]" strokeWidth={1.8} />
                  </div>
                  <div className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-[#0044CC] text-white text-[10px] font-bold flex items-center justify-center">{i + 1}</div>
                </div>
                <p className="text-white text-xs sm:text-sm font-medium text-center leading-tight">{s[`title_${language}`] || s.title_en}</p>
              </div>
              {i < steps.length - 1 && (
                <div className="flex-shrink-0 mb-6 mx-1">
                  <div className="w-6 sm:w-10 h-px border-t-2 border-dashed border-white/15" />
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
